// extracted by mini-css-extract-plugin
export default {"content":"CancelFundsCheckModal_content__SJa2W zb-modal-body"};